import { pick } from 'lodash-es';
import commonSetting from '@intelligence/components/DownloadCommon/DownloadPage/configs/commonSetting';
import { generateSortKey } from '@intelligence/v3/utils/common';
import { getAllCountryCodesByRegions } from '@intelligence/v3/utils/region';
import { buildMetricFiltersFetchParams } from '@intelligence/v3/utils/topcharts';
import { getDateRangeFileName } from '../utils';
import { SortType } from '@home/enums/common';
import { DATASOURCE_METRIC_KEY_MAP } from '@intelligence/v3/_config/metrics';

const getDownloadApiParams = (params?: IRecord | null): IMetricDataGamesFetchParams => {
  if (!params) return {} as unknown as IMetricDataGamesFetchParams;

  const metricFilters = buildMetricFiltersFetchParams([
    { metric: DATASOURCE_METRIC_KEY_MAP.SENSORTOWER__CROSS_APP_USAGE, metricValue: params?.mobile_overlap },
  ]);

  const groupBys = ['market', 'date'];

  const orderBys = (() => {
    const metricOrderBy = generateSortKey(DATASOURCE_METRIC_KEY_MAP.SENSORTOWER__ACTIVE_USERS, SortType.Desc);
    const downloadGroupBys = groupBys.map((groupBy) => `${groupBy} desc`);
    return [...downloadGroupBys, metricOrderBy];
  })();

  return {
    ...pick(params, ['granularity', 'start_date', 'end_date']),
    filter: {
      target_iegg_genre: params?.iegg_genre || [],
      target_sensortower_genre: params?.sensortower_genre || [],
      target_appannie_genre: params?.appannie_genre || [],
      iegg_genre: [],
      sensortower_genre: [],
      appannie_genre: [],
      metric_filter: metricFilters,
      tags: [],
      companies: [],
      start_release_date: '',
      end_release_date: '',
    },
    metrics: [
      DATASOURCE_METRIC_KEY_MAP.SENSORTOWER__ACTIVE_USERS,
      DATASOURCE_METRIC_KEY_MAP.SENSORTOWER__CROSS_APP_USAGE,
      DATASOURCE_METRIC_KEY_MAP.SENSORTOWER__CROSS_AFFINITY,
    ],
    markets: getAllCountryCodesByRegions(params?.regionOptions),
    platforms: ['appstore', 'googleplay'],
    group_by: groupBys,
    order_by: orderBys,
    page: 1,
    page_size: 9999,
    game_ids: params?.game_ids || [],
    rank_game_ids: [],
    top_size: 9999,
    use_custom_fields: [
      'entity_name',
      'publisher',
      'publisher_country_abbre',
      'publisher_country_name_en',
      'parent_publisher',
      'genre',
      'sub_genre',
      'iegg_genre',
      'iegg_sub_genre',
      'sensortower_genre',
      'sensortower_sub_genre',
      'is_special_release_time',
      'release_time',
      'release_time_en',
      'release_time_cn',
      'sensortower_tag',
    ],
  };
};

export default (params?: IRecord | null) => {
  return {
    ...commonSetting,
    downloadMode: 'commonConf',
    downloadConfigKey: 'mobileOverlapDetails',
    downloadFetchApi: '/api/v1/intelligence_pc/mobile/metrics',
    downloadApiParams: getDownloadApiParams(params),
    isUsingNewMethod: false,
    fetchOnlyOnce: true,
    dataKey: undefined,
    $$fileName: getDateRangeFileName(params),
    regionOptions: params?.regionOptions,
  };
};
